// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1v9he","rootCenter":"LoadMoreObserver_rootCenter__3ZwFT","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3sfIJ"};